// const AJAX_URL = '/wp-admin/admin-ajax.php'

jQuery(document).foundation()
jQuery(document).ready(function($) {
    joints_wp_fixes()
    // AOS.init()  //Enable if loading AOS

    if ($('.image-slider').length > 0) {
        $('.image-slider').slick({
            dots: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
            slidesToShow: 1,
            adaptiveHeight: true,
            prevArrow: false,
            nextArrow: false,
            fade: true,
        })
    }

    if ($('.latest-blog-news').length > 0) {
        $(window).on('resize'),
            function() {
                $('.match-height-large').matchHeight({
                    byRow: true,
                })
            }
    }

    //Submenus on Mobile fix
    var $subMenuAnchors = jQuery('.off-canvas .is-accordion-submenu-parent > a')
    $subMenuAnchors.each(function() {
        if (jQuery(this).attr('href') !== '#') {
            var markup =
                '<li class="menu-item menu-item-type-post_type menu-item-object-page is-submenu-item is-accordion-submenu-item" role="menuitem">'
            markup += '<a href="' + jQuery(this).attr('href') + '">'
            markup += 'Go to - ' + jQuery(this).text()
            markup += '</a>'
            markup += '</li>'
            jQuery(this)
                .parent()
                .find('.is-accordion-submenu')
                .prepend(markup)
        }
    })

    /* Toggle Video Modal
  -----------------------------------------*/
	function toggle_video_modal() {

	    // Click on video thumbnail or link
	    $(".js-trigger-video-modal").on("click", function(e){

          // prevent default behavior for a-tags, button tags, etc.
	        e.preventDefault();

          // Grab the video ID from the element clicked
          var id = $(this).attr('data-youtube-id');

          // Autoplay when the modal appears
          // Note: this is intetnionally disabled on most mobile devices
          // If critical on mobile, then some alternate method is needed
          var autoplay = '?autoplay=0';

          // Don't show the 'Related Videos' view when the video ends
          var related_no = '&rel=0';

          // String the ID and param variables together
        //   var src = '//www.youtube.com/embed/'+id+autoplay+related_no;
          var src = '//www.youtube.com/embed/'+id+autoplay+related_no;

          // Pass the YouTube video ID into the iframe template...
          // Set the source on the iframe to match the video ID
          $("#youtube").attr('src', src);

          // Add class to the body to visually reveal the modal
          $("body").addClass("show-video-modal noscroll");

      });

        // Close and Reset the Video Modal
      function close_video_modal() {

        event.preventDefault();

        // re-hide the video modal
        $("body").removeClass("show-video-modal noscroll");

        // reset the source attribute for the iframe template, kills the video
        $("#youtube").attr('src', '');

      }
      // if the 'close' button/element, or the overlay are clicked
	    $('body').on('click', '.close-video-modal, .video-modal .overlay', function(event) {

          // call the close and reset function
          close_video_modal();

      });
      // if the ESC key is tapped
      $('body').keyup(function(e) {
          // ESC key maps to keycode `27`
          if (e.keyCode == 27) {

            // call the close and reset function
            close_video_modal();

          }
      });
	}
	toggle_video_modal();
})
